// Primary Scheme Report — scheme usage on Primary (distributor→company)
// orders only. Bifurcated from Scheme Report (Secondary/retailer only) so
// the two channels don't mix in one report.
import TransactionReportPage from "./TransactionReportPage";

export default function PrimarySchemeReport() {
  return (
    <TransactionReportPage
      slug="primary-schemes"
      testidPrefix="primary-scheme-report"
      title="Primary Scheme Report"
      subtitle="Every Primary order line a scheme fired on — reward given, discount, free qty."
      initialDaysBack={30}
      filterConfig={{ showUser: true, showDistributor: true }}
    />
  );
}
